import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { errorMsgHandler, regEmail, regPassword, regPhone } from "common/hooks/utils/utils";
import { labelStyle } from "user/components/form/CategoryTab";
import Header from "user/components/common/Header";
import Logo from "user/components/common/Logo";
import { CompanySearchOverlay, SystemPopup } from "user/components/common/Overlay";
import { usePostSignup } from "common/hooks/user/account/usePostSignup";
import useOverlay, { OverlayWrapper } from "common/hooks/user/useOverlay";
import InputField, { MobileInputField, PasswordInputField } from "user/components/common/InputField";
import { ReactComponent as SelectIcon } from "../../../common/assets/icons/selectIcon.svg";

type InitialValuesProps = {
    m_category: string;
    customer_idx: string;
    customer_idx_name: string;
    customer_name: string;
    m_name: string;
    m_email: string;
    m_mobile: string;
    m_password: string;
    m_password_check: string;
};
const initialValues: InitialValuesProps = {
    m_category: "1",
    customer_idx: "",
    customer_idx_name: "",
    m_name: "",
    customer_name: "",
    m_email: "",
    m_mobile: "",
    m_password: "",
    m_password_check: "",
};

export default function Signup() {
    const [registered, setRegistered] = useState(false);
    const { overlay, closeOverlay, openOverlay } = useOverlay();
    const { mutate, isPending } = usePostSignup();

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { setSubmitting }) => {
            setSubmitting(true);
            // console.log(values);
            // 회사회원(customer_idx: 1)
            // 개인회원(customer_idx: 2)
            const body = {
                customer_idx: values.m_category === "1" ? Number(values.customer_idx) : null,
                customer_name: values.m_category === "1" ? values.customer_idx_name : values.customer_name,
                m_category: Number(values.m_category),
                m_name: values.m_name,
                m_email: values.m_email,
                m_mobile: values.m_mobile,
                m_password: values.m_password,
            };
            // console.log(body);
            // return;
            mutate(
                { ...body },
                {
                    onSuccess: () => {
                        setRegistered(true);
                    },
                    onError: (error: any) => {
                        const err_msg = errorMsgHandler(error);
                        // console.log(err_msg);
                        openOverlay(<SystemPopup message={err_msg} onClickClose={closeOverlay} />);
                    },
                },
            );
        },
        validate: values => {
            const errors: Record<string, string> = {};
            if (!values.customer_idx_name && !values.customer_idx && values.m_category === "1") {
                errors.customer_idx_name = "회사와 부서를 선택해주세요.";
            }
            if (!values.customer_name && values.m_category === "2") {
                errors.customer_name = "회사와 부서를 선택해주세요.";
            }
            if (!values.m_name) {
                errors.m_name = "이름을 입력해주세요.";
            }
            if (!values.m_mobile || !regPhone.test(values.m_mobile)) {
                errors.m_mobile = "연락처를 확인하세요.";
            }
            if (!values.m_email || !regEmail.test(values.m_email)) {
                errors.m_email = "이메일 주소를 확인하세요.";
            }
            if (!values.m_password || !regPassword.test(values.m_password)) {
                errors.m_password = "영문 숫자 조합 6자리 이상 입력하세요.";
            }
            if (!values.m_password_check || !regPassword.test(values.m_password_check)) {
                errors.m_password_check = "영문 숫자 조합 6자리 이상 입력하세요.";
            }
            if (values.m_password !== values.m_password_check) {
                errors.m_password_check = "비밀번호가 일치하지 않습니다.";
            }
            return errors;
        },
        // validateOnMount: true,
    });

    const errorKeys = Object.keys(formik.errors);
    const isInValid = errorKeys.length > 0;

    return (
        <OverlayWrapper overlay={overlay} closeOverlay={closeOverlay}>
            <div
                className={`min-h-[100dvh] flex-col flex items-center relative ${registered ? "max-h-[100dvh] overflow-hidden" : "max-h-none"}`}
            >
                <Header goBack title="회원가입" />
                <div className="wrapper py-[16px] flex flex-col items-center gap-10 w-full [&_form]:w-full">
                    <form onSubmit={formik.handleSubmit}>
                        <div className="flex flex-col gap-6">
                            <div className="flex flex-col gap-3 pb-[30px]">
                                {/* 회사/개인 선택 */}
                                <div role="group" className="bg-primary3 rounded-[8px] p-[4px] flex">
                                    <label htmlFor="1" className={labelStyle}>
                                        <input
                                            type="radio"
                                            id="1"
                                            name="m_category"
                                            value="1"
                                            checked={formik.values.m_category === "1"}
                                            onChange={e => {
                                                formik.setFieldValue("m_category", e.target.value);
                                            }}
                                            className="appearance-none"
                                        />
                                        회사
                                    </label>
                                    <label htmlFor="2" className={labelStyle}>
                                        <input
                                            type="radio"
                                            id="2"
                                            name="m_category"
                                            value="2"
                                            checked={formik.values.m_category === "2"}
                                            onChange={e => {
                                                formik.setFieldValue("m_category", e.target.value);
                                            }}
                                            className="appearance-none"
                                        />
                                        개인
                                    </label>
                                </div>

                                <div className={`flex flex-col`}>
                                    {formik.values.m_category === "1" ? (
                                        <React.Fragment>
                                            <label htmlFor="customer_idx_name" className="mb-[4px] text-[#484964] leading-[24px]">
                                                회사
                                            </label>
                                            <div
                                                className={`overflow-hidden flex items-center justify-between rounded-xl border bg-white pr-[20px] ${formik.touched.customer_idx_name && errorKeys.includes("customer_idx_name") ? "[&:has(input)]:border-[#DC2626]" : "[&:has(input:focus)]:border-[#4B632B]"}`}
                                                onClick={() =>
                                                    openOverlay(
                                                        <CompanySearchOverlay
                                                            category={1}
                                                            onClickClose={closeOverlay}
                                                            onClickTarget={({ name, idx }: { name: string; idx: number }) => {
                                                                formik.setFieldValue("customer_idx", idx);
                                                                formik.setFieldValue("customer_idx_name", name);
                                                                closeOverlay();
                                                            }}
                                                        />,
                                                    )
                                                }
                                            >
                                                <input
                                                    name="customer_idx_name"
                                                    id="customer_idx_name"
                                                    readOnly
                                                    value={formik.values.customer_idx_name}
                                                    placeholder="회사와 부서를 검색하세요"
                                                    className="cursor-pointer p-3 w-full placeholder:text-[#ddd] text-lg focus:outline-none focus:ring-0"
                                                />
                                                <SelectIcon />
                                            </div>
                                            {formik.errors.customer_idx_name && formik.touched.customer_idx_name ? (
                                                <div className="text-[#DC2626] flex gap-[6px] text-[14px] mt-[4px]">
                                                    {formik.errors.customer_idx_name}
                                                </div>
                                            ) : null}
                                        </React.Fragment>
                                    ) : null}
                                    {formik.values.m_category === "2" ? (
                                        <React.Fragment>
                                            <label htmlFor="customer_name" className="mb-[4px] text-[#484964] leading-[24px]">
                                                회사
                                            </label>

                                            <InputField
                                                id="customer_name"
                                                name="customer_name"
                                                value={formik.values.customer_name}
                                                onChange={formik.handleChange}
                                                placeholder="회사와 부서를 입력해주세요"
                                                onClickClearButton={() => formik.setFieldValue("customer_name", "")}
                                                error={formik.touched.customer_name && errorKeys.includes("customer_name")}
                                                textMaxLength={30}
                                            />
                                            {formik.errors.customer_name && formik.touched.customer_name ? (
                                                <div className="text-[#DC2626] flex gap-[6px] text-[14px] mt-[4px]">
                                                    {formik.errors.customer_name}
                                                </div>
                                            ) : null}
                                        </React.Fragment>
                                    ) : null}
                                </div>

                                <div className={`flex flex-col`}>
                                    <label htmlFor="m_name" className="mb-[4px] text-[#484964] leading-[24px]">
                                        이름
                                    </label>

                                    <InputField
                                        id="m_name"
                                        name="m_name"
                                        value={formik.values.m_name}
                                        onChange={formik.handleChange}
                                        placeholder="연락처를 입력해주세요"
                                        onClickClearButton={() => formik.setFieldValue("m_name", "")}
                                        error={formik.touched.m_name && errorKeys.includes("m_name")}
                                        textMaxLength={20}
                                    />

                                    {formik.errors.m_name && formik.touched.m_name ? (
                                        <div className="text-[#DC2626] flex gap-[6px] text-[14px] mt-[4px]">{formik.errors.m_name}</div>
                                    ) : null}
                                </div>

                                <div className={`flex flex-col`}>
                                    <label htmlFor="m_mobile" className="mb-[4px] text-[#484964] leading-[24px]">
                                        연락처
                                    </label>

                                    <MobileInputField
                                        id="m_mobile"
                                        name="m_mobile"
                                        value={formik.values.m_mobile}
                                        onChange={formik.handleChange}
                                        placeholder="연락처를 입력해주세요"
                                        onClickClearButton={() => formik.setFieldValue("m_mobile", "")}
                                        error={formik.touched.m_mobile && errorKeys.includes("m_mobile")}
                                    />

                                    {formik.errors.m_mobile && formik.touched.m_mobile ? (
                                        <div className="text-[#DC2626] flex gap-[6px] text-[14px] mt-[4px]">{formik.errors.m_mobile}</div>
                                    ) : null}
                                </div>

                                <div className={`flex flex-col`}>
                                    <label htmlFor="m_email" className="mb-[4px] text-[#484964] leading-[24px]">
                                        이메일
                                    </label>
                                    <InputField
                                        id="m_email"
                                        name="m_email"
                                        value={formik.values.m_email}
                                        onChange={formik.handleChange}
                                        placeholder="이메일을 입력해주세요"
                                        onClickClearButton={() => formik.setFieldValue("m_email", "")}
                                        error={formik.touched.m_email && errorKeys.includes("m_email")}
                                    />

                                    {formik.errors.m_email && formik.touched.m_email ? (
                                        <div className="text-[#DC2626] flex gap-[6px] text-[14px] mt-[4px]">{formik.errors.m_email}</div>
                                    ) : null}
                                </div>

                                <div className={`flex flex-col`}>
                                    <label htmlFor="m_password" className="mb-[4px] text-[#484964] leading-[24px]">
                                        비밀번호
                                    </label>
                                    <PasswordInputField
                                        id="m_password"
                                        name="m_password"
                                        value={formik.values.m_password}
                                        onChange={formik.handleChange}
                                        placeholder="영문 숫자 조합 6자리 이상"
                                        error={formik.touched.m_password && errorKeys.includes("m_password")}
                                        onClickClearButton={() => formik.setFieldValue("m_password", "")}
                                    />

                                    {formik.errors.m_password && formik.touched.m_password ? (
                                        <div className="text-[#DC2626] flex gap-[6px] text-[14px] mt-[4px]">{formik.errors.m_password}</div>
                                    ) : null}
                                </div>

                                <div className={`flex flex-col`}>
                                    <label htmlFor="m_password_check" className="mb-[4px] text-[#484964] leading-[24px]">
                                        비밀번호 확인
                                    </label>

                                    <PasswordInputField
                                        id="m_password_check"
                                        name="m_password_check"
                                        value={formik.values.m_password_check}
                                        onChange={formik.handleChange}
                                        placeholder="영문 숫자 조합 6자리 이상"
                                        error={formik.touched.m_password_check && errorKeys.includes("m_password_check")}
                                        onClickClearButton={() => formik.setFieldValue("m_password_check", "")}
                                    />

                                    {formik.errors.m_password_check && formik.touched.m_password_check ? (
                                        <div className="text-[#DC2626] flex gap-[6px] text-[14px] mt-[4px]">
                                            {formik.errors.m_password_check}
                                        </div>
                                    ) : null}
                                </div>
                            </div>

                            <button
                                type="submit"
                                data-disabled={isInValid}
                                className="shadow-custom bg-gradient-to-r from-[#273219] to-[#4B632B] text-white font-bold text-[18px] leading-[28px] py-[12px] rounded-[12px] data-[disabled='true']:opacity-[0.3]"
                            >
                                완료
                            </button>
                        </div>
                    </form>
                </div>

                {registered && (
                    <div className="max-h-[100dvh] flex flex-col absolute inset-0 bg-gradient-to-b from-[#fff] to-[#F4FCEA]">
                        <Header title="회원가입 완료" />
                        <div className="flex-1 flex flex-col px-[28px] pt-[60px] pb-[24px]">
                            <div className="flex-1 flex flex-col items-center gap-[40px]">
                                <Logo />
                                <div className="text-center">
                                    <p className="text-[#273219] font-bold text-[24px] leading-[36px] mb-[8px]">회원가입이 완료되었어요!</p>
                                    <p className="break-keep text-[18px] leading-[28px]">
                                        회원가입 시 입력했던 연락처와 비밀번호로 로그인해주세요.
                                    </p>
                                </div>
                            </div>
                            <Link
                                to="/"
                                className="shadow-custom bg-gradient-to-r from-[#273219] to-[#4B632B] text-white font-bold text-[18px] leading-[28px] py-[12px] rounded-[12px] text-center"
                            >
                                로그인하기
                            </Link>
                        </div>
                    </div>
                )}
            </div>
        </OverlayWrapper>
    );
}
